
import React, { useEffect, useState } from "react";
import { Controller } from 'react-hook-form'
import Select, { components } from 'react-select';

const ModifierOption = (props) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {}}
      className="me-2"
    />
    <label className="mb-0">{props.label}</label>
  </components.Option>
);

const SelectedCountValueContainer = ({ children, ...props }) => {
  const selected = props.getValue();
  const [, inputChild] = children;
  return (
    <components.ValueContainer {...props}>
      {selected.length > 0 ? (
        <span className="text-truncate">{selected.length} selected</span>
      ) : (
        !props.selectProps.inputValue && (
          <span className="text-muted">{props.selectProps.placeholder}</span>
        )
      )}
      {inputChild}
    </components.ValueContainer>
  );
};

function EditOtherDescription({ register, errors, control,modifierList,watch ,setValue}) {
 
const  modifierOptions = modifierList.map((modifier) => ({
    value: modifier.guid,
    label: modifier.name,
  }));

  const isStockItem = watch("otherDescription.isStockItem");
  const isDailyStockItem = watch("otherDescription.isDailyStockItem");

  
  // 👇 Automatically uncheck Daily Stock when Is Stock Item is unchecked
  useEffect(() => {
    if (!isStockItem && isDailyStockItem) {
      setValue("otherDescription.isDailyStockItem", false);
    }
  }, [isStockItem, isDailyStockItem, setValue]);
  
  return (
    <div>
      <div>
        <div className="modal-body custom-modal-body">
          <div className="branch-tabs col-12 align-items-center justify-content-between">

          </div>
          <form >
            <div className="row">

            <div className="col-md-6 col-sm-12">
              <div className="col-auto input-blocks">
                <label className="col-form-label">Other Description</label>
              </div>
              <div className="col input-blocks mb-3">
                <input type="text" className="form-control" {...register("otherDescription.otherDescription")} />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="col-auto input-blocks">
                <label className="col-form-label">Calories</label>
              </div>
              <div className="col input-blocks mb-3">
                <input type="number" className="form-control" placeholder="Calories" {...register("otherDescription.calories")} />
              </div>
            </div>
            <div className=" col-md-6 col-sm-12">
              <div className="col-auto input-blocks ">
                <label className="col-form-label">HSN code</label>
              </div>
              <div className="col input-blocks mb-3">
                <input type="text" id="" className="form-control" {...register("otherDescription.hsnCode")} />
              </div>
            </div>
  <div className="col-md-6 col-sm-12">
            <label>Select Modifiers</label>
<Controller
  name="otherDescription.modifiers"
  control={control}
  render={({ field }) => {
    const selectedValues = (field.value || []).map(m => ({
      value: m.guid,
      label: m.name,
    }));

    return (
      <Select
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        placeholder="Select modifiers"
        // 🔑 Options from global modifier list
        options={(modifierList || []).map(m => ({
          value: m.guid,
          label: m.name,
        }))}
        // 🔑 Selected from RHF state
        value={selectedValues}
        onChange={(selected) =>
          field.onChange(
            (selected || []).map(s => ({
              guid: s.value,
              name: s.label,
            }))
          )
        }
        components={{ Option: ModifierOption, ValueContainer: SelectedCountValueContainer }}
        menuPortalTarget={document.body}
        styles={{
          control: (base) => ({ ...base, minHeight: 40, overflow: "hidden" }),
          valueContainer: (base) => ({ ...base, flexWrap: "nowrap", overflow: "hidden" }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    );
  }}
/>






          </div>

            </div>


            <div className="row mt-3">

            <div className="col-lg-3 col-sm-12">
            <input type="checkbox" className="" {...register("otherDescription.isRateVaryProduct")} /> Is product price variable?
            </div>
            <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
            When this setting enabled, we can change the price of product while billing, a popup box will show in sales screen
                        </div>
            </div>
            <div className="row">

            <div className="col-lg-3 col-sm-12">
            <input type="checkbox" className="" {...register("otherDescription.isStockItem")} />Is Stock Item
            </div>
            <div className="col-lg-9 col-md-6 col-sm-12 general_decription">
 When enabled, this product will be treated as a stock item.
                        </div>
            </div>
            {/* 👇 Daily Stock Item always visible, but disabled when Is Stock Item = false */}
        <div className="row">
          <div className="col-lg-3 col-sm-12">
            <input
              type="checkbox"
              {...register("otherDescription.isDailyStockItem")}
              disabled={!isStockItem} // 👈 disables when false
            />{" "}
            Daily Stock Item
          </div>
          <div
            className={`col-lg-9 col-sm-12 general_decription ${
              !isStockItem ? "text-muted" : ""
            }`}
          >
            When enabled, this product is considered a daily stock product.
          </div>
        </div>

          </form>
        </div>

      </div>
    </div>
  )
}

export default EditOtherDescription

